import {
  Component,
  Input,
  OnChanges,
  EventEmitter,
  Output,
  SimpleChanges,
} from '@angular/core'
import { Address, Country, Order } from '@xfeet-workspace/xfeet-api-client/models';
import { OrderApi } from '@xfeet-workspace/xfeet-api-client/services';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-widget-pickup-display-address',
    templateUrl: './widget-pickup-display-address.component.html',
    styleUrls: ['./widget-pickup-display-address.component.scss'],
    standalone: false
})
export class WidgetPickupDisplayAddressComponent implements OnChanges {

  @Input() order?: Order | null = null;
  @Input() address?: Address | null = null;

  @Input() selected = false;
  @Input() addressTemplate: any;
  @Output() select = new EventEmitter<Order | Address>();
  selectable = false;
  context: {
    selected: boolean;
    select: () => void;
    addressName1: string;
    addressName2?: string;
    addressLine1: string;
    addressLine2?: string;
    postalCode: string;
    city: string;
    country: Country | string;
    phone?: string;
    pickup?: boolean;
  } = {
    selected: this.selected,
    select: this.onSelect.bind(this),
    addressName1: '',
    addressLine1: '',
    postalCode: '',
    city: '',
    country: '',
    pickup: false
  };

  constructor(private orderApi: OrderApi, private toastr: ToastrService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['order'] || changes['address']) {
      this.updateContext();
    } else if (changes['selected']) {
      this.context = { ...this.context, selected: this.selected };
    }
  }

  onSelect(): void {
    if (this.selectable) {
      if (this.order) {
        this.select.emit(this.order);
      } else if (this.address) {
        this.select.emit(this.address);
      }
    }
  }

  private updateContext(): void {
    if (!this.order && !this.address) {
      return;
    }
    if (this.order?.id && !this.address) {
      this.orderApi.mgmtOrderPickupControllerFindPickupPoint({id:this.order.id})
      .subscribe({
        next: (pickupPoint) => {
          this.selectable = true;
          if (pickupPoint.local) {
            this.context = {
              selected: this.selected,
              select: this.onSelect.bind(this),
              addressName1: pickupPoint.local.addressName1 || '',
              addressName2: pickupPoint.local.addressName2,
              addressLine1: pickupPoint.local.addressLine1 || '',
              addressLine2: pickupPoint.local.addressLine2,
              postalCode: pickupPoint.local.postalCode || '',
              city: pickupPoint.local.city || '',
              country: pickupPoint.local.country || '',
              phone: pickupPoint.local.phone,
              pickup: true
            };
          } else {
            this.context = {
              selected: this.selected,
              select: this.onSelect.bind(this),
              addressName1: this.order?.shipping?.addressName1 || '',
              addressName2: pickupPoint.colissimo?.nom || '',
              addressLine1: pickupPoint.colissimo?.adresse1 || '',
              addressLine2: pickupPoint.colissimo?.adresse2 || '',
              city: pickupPoint.colissimo?.localite || '',
              country: pickupPoint.colissimo?.libellePays || '',
              postalCode: pickupPoint.colissimo?.codePostal || '',
              pickup: true
            }
          }
        },
        error: (error) => {
          this.selectable = false;
          console.error('Error fetching pickup point details:', error);
          this.toastr.error('Error fetching pickup point details');
          this.context = {
              selected: this.selected,
              select: this.onSelect.bind(this),
              addressName1: this.order?.shipping.pickupLocationExternalId || '',
              addressName2: undefined,
              addressLine1: 'Introuvable',
              addressLine2: undefined,
              city: 'Introuvable',
              country: 'Introuvable',
              postalCode: 'Introuvable',
              pickup: true
            }
        }
      });
    } else {
      this.selectable = true;
      this.context = {
        selected: this.selected,
        select: this.onSelect.bind(this),
        addressName1: this.address?.addressName1 || '',
        addressName2: this.address?.addressName2 || '',
        addressLine1: this.address?.addressLine1 || '',
        addressLine2: this.address?.addressLine2 || '',
        city: this.address?.city || '',
        country: this.address?.country || '',
        postalCode: this.address?.postalCode || '',
        phone: this.address?.phone || '',
        pickup: false,
      };
    }
  }
}
